import React, {useEffect, useState} from "react";
import classes from "../../pages/main/main.module.css";
import {getFormattedLocalDate} from "../../services/dateService";
import {motion, useAnimation} from "framer-motion";
import {useInView} from "react-intersection-observer";
import DeleteButton from "../buttons/DeleteButton";
import {useNews} from "../../context/NewsContext";
import {EditButton} from "../buttons/EditButton";
import {CloseButton} from "../buttons/CloseButton";
import {OkButton} from "../buttons/OkButton";
import {updateNews} from "../../clients/NewsApiClient";
import {PhotoUpdater} from "../photos/PhotoUpdater";
import Text from "../text/Text";
import InputTextArea from "../fields/InputTextArea";
import sendSuccessAlert from "../../services/alertService";
import InputDate from "../fields/InputDate";

const News = (props) => {

    const [redacted, setRedacted] = useState(false);
    const {
        setDeleteIsOpen,
        setSelectedNews,
        refreshNews,
        setPhotoRedacted
    } = useNews();
    const [title, setEditedTitle] = useState(props.el.title);
    const [text, setEditedText] = useState(props.el.text);
    const [date, setDate] = useState(new Date());
    const controls = useAnimation();
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    async function submitNews() {
        await updateNews(props.el.id, title, props.el.author, text, date);
        await refreshNews()
        setRedacted(false);
        sendSuccessAlert('Новость успешно отредактирована')
    }

    useEffect(() => {
        if (inView) {
            controls.start({opacity: 1, y: 0});
        }
    }, [inView, controls]);

    useEffect(() => {
        setEditedTitle(props.el.title);
        setEditedText(props.el.text);
        setDate(new Date(props.el.event_date));
    }, [redacted, props.el.event_date, props.el.title, props.el.text]);

    return (
        <div>
            <motion.div
                ref={ref}
                initial={{opacity: 0, y: 30}}
                animate={controls}
                transition={{duration: 0.6}}
                className="mb-3 p-3 h-100"
            >
                <div className={`${classes.news_card} h-100 d-flex flex-column p-3`}>
                    {!redacted && (
                        <div>
                            <h4 className={classes.news_card_title}>{props.el.title}</h4>

                            {props.el.content_url && (
                                <div className="ratio ratio-1x1 mb-3">
                                    <img
                                        src={props.el.content_url}
                                        alt="alt"
                                        className={`img-fluid w-100 h-100 object-fit-cover ${classes.img_card}`}
                                    />
                                    {props.isUserAdmin && (
                                        <PhotoUpdater onClick={() => {
                                            setPhotoRedacted(true)
                                            setSelectedNews(props.el)
                                        }}/>
                                    )}
                                </div>
                            )}

                            <Text text={props.el.text}/>

                            {props.el.event_date === null ? null : (
                                <div className="text-end w-100 mt-auto">
                                    Дата мероприятия: {getFormattedLocalDate(props.el.event_date)}
                                </div>
                            )}
                        </div>
                    )}

                    {redacted && (
                        <div>
                            <div className="ratio ratio-1x1 mb-3">
                                <img
                                    src={props.el.content_url}
                                    alt="alt"
                                    className={`img-fluid w-100 h-100 object-fit-cover ${classes.img_card}`}
                                />
                            </div>

                            <label className={classes.label}>
                                Заголовок <b className={classes.required}>*</b>
                            </label>
                            <input
                                placeholder={'Отредактируйте заголовок'}
                                type="text"
                                className={classes.input}
                                onChange={(e) => setEditedTitle(e.target.value)}
                                value={title}
                                required
                            />

                            <InputDate
                                value={date}
                                onChange={(e) => setDate(e)}
                                placeholder={'Укажите дату'}
                                text={'Дата мероприятия'}
                                required={true}
                            />

                            <label className={classes.label}>
                                Описание <b className={classes.required}>*</b>
                            </label>
                            <InputTextArea
                                placeholder={'Отредактируйте суть новости'}
                                className={classes.textarea}
                                value={text}
                                onChange={(e) => setEditedText(e)}
                            />


                        </div>
                    )}

                    <div className="text-end w-100 mt-auto">
                        {!redacted && (
                            <div>Опубликовано: {getFormattedLocalDate(props.el.created_at)}</div>
                        )}
                        {props.isUserAdmin && !redacted && (
                            <div className={'d-flex justify-content-end'}>
                                <EditButton onClick={
                                    () => {
                                        setRedacted(true)
                                        setSelectedNews(props.el)
                                    }
                                }/>
                                <DeleteButton onClick={
                                    () => {
                                        setSelectedNews(props.el)
                                        setDeleteIsOpen(true)
                                    }
                                }/>
                            </div>
                        )}

                        {props.isUserAdmin && redacted && (
                            <div className={'d-flex justify-content-end'}>
                                <OkButton onClick={submitNews}/>
                                <CloseButton onClick={
                                    () => {
                                        setRedacted(false)
                                        setSelectedNews({})
                                    }
                                }/>
                            </div>
                        )}
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default News;
